// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"533":"b418582f","943":"9de1c76f"}[chunkId] + ".chunk.js";
};